import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { site, venue } from '../data/site';

const Contact: React.FC = () => (
  <section className="section">
    <Container>
      <div className="text-center">
        <h1 className="section-title">Contact</h1>
        <hr className="section-rule" />
      </div>

      <Row className="justify-content-center g-4">
        <Col md={6} lg={4}>
          <div className="border p-4 h-100 text-center">
            <h2 className="h5">Email</h2>
            <p className="mb-0">
              <a href={`mailto:${site.email}`}>{site.email}</a>
            </p>
          </div>
        </Col>
        <Col md={6} lg={4}>
          <div className="border p-4 h-100 text-center">
            <h2 className="h5">Phone</h2>
            <p className="mb-0">
              <a href={site.phoneHref}>{site.phone}</a>
            </p>
          </div>
        </Col>
        <Col md={6} lg={4}>
          <div className="border p-4 h-100 text-center">
            <h2 className="h5">Facebook</h2>
            <p className="mb-0">
              <a href={site.facebook} target="_blank" rel="noopener noreferrer">
                Art on the Lake Festival
              </a>
            </p>
          </div>
        </Col>
      </Row>

      <Row className="justify-content-center mt-5">
        <Col lg={8} className="text-center">
          <h2 className="section-title h4">Festival location</h2>
          <hr className="section-rule" />
          <p className="mb-1">{venue.name}</p>
          <p className="mb-3">{venue.address}</p>
          <a
            className="btn btn-secondary px-4"
            href={venue.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open in Maps
          </a>
        </Col>
      </Row>
    </Container>
  </section>
);

export default Contact;
